import { render } from "./AssetOwnerModal.vue?vue&type=template&id=140f4bb2"
import script from "./AssetOwnerModal.vue?vue&type=script&lang=js"
export * from "./AssetOwnerModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__